"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountType = void 0;
var AccountType;
(function (AccountType) {
    AccountType["Vip"] = "VIP";
    AccountType["Twitter"] = "Twitter";
    AccountType["Facebook"] = "Facebook";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
